export const renderConditionQuotaText = (
  data:
    | {
        limitOrderDay: boolean;
        limitQuantityOrder: boolean;
        limitOrderDayCondition?: {
          allShop: boolean;
          perShop: boolean;
          orderAmount: number;
        };
      }
    | null
    | undefined,
): string[] => {
  if (!data) {
    return ["-"];
  }

  const texts: string[] = [];

  if (data.limitQuantityOrder) {
    texts.push("จำกัดจำนวนซื้อรายสินค้า/คำสั่งซื้อ");
  }
  if (data.limitOrderDay && data.limitOrderDayCondition) {
    const { allShop, perShop, orderAmount } = data.limitOrderDayCondition;
    if (allShop) {
      texts.push(`จำกัดคำสั่งซื้อ/วัน | ทุกร้าน ${orderAmount} ครั้ง/วัน`);
    } else if (perShop) {
      texts.push(`จำกัดคำสั่งซื้อ/วัน | รายร้าน`);
    }
  }

  return texts.length > 0 ? texts : ["-"];
};
